import { render } from "./Page.vue?vue&type=template&id=ab7e4c88"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import "./Page.vue?vue&type=style&index=0&id=ab7e4c88&lang=css"
script.render = render

export default script